import dayjs from "@/src/shared/utils/dayjs";
import { TimeSettings } from "./type";
import { dayJsToDaysOfWeekMap } from "./constants";

export const isNotificationShown = (settings?: TimeSettings): boolean => {
    if (!settings) return true;

    const now = new Date();
    const currentDate = dayjs(now);
    const currentDateString = dayjs(now).format("YYYY-MM-DD");

    if (settings.dateStart) {
        if (!currentDate.isAfter(settings.dateStart)) {
            return false;
        }
    }
    if (settings.dateEnd) {
        if (!currentDate.isBefore(settings.dateEnd)) {
            return false;
        }
    }
    if (settings.timeStart) {
        if (
            !currentDate.isAfter(`${currentDateString}T${settings.timeStart}`)
        ) {
            return false;
        }
    }
    if (settings.timeEnd) {
        if (!currentDate.isBefore(`${currentDateString}T${settings.timeEnd}`)) {
            return false;
        }
    }

    if (settings.daysSettings) {
        const currentDay = dayJsToDaysOfWeekMap[currentDate.day()];
        const currentDaySettings = settings.daysSettings[currentDay];
        const isSettingsByDayEnabled = Object.values(
            settings.daysSettings,
        ).some((day) => !!day);

        if (!isSettingsByDayEnabled) {
            return true;
        }

        if (!currentDaySettings || !currentDaySettings?.enabled) {
            return false;
        }

        if (currentDaySettings.start) {
            if (
                !currentDate.isAfter(
                    `${currentDateString}T${currentDaySettings.start}`,
                )
            ) {
                return false;
            }
        }
        if (currentDaySettings.end) {
            if (
                !currentDate.isBefore(
                    `${currentDateString}T${currentDaySettings.end}`,
                )
            ) {
                return false;
            }
        }
    }

    return true;
};

export const isNotificationHidden = (settings?: TimeSettings): boolean => {
    if (!settings) return true;

    const now = new Date();
    const currentDate = dayjs(now);
    const currentDateString = dayjs(now).format("YYYY-MM-DD");

    if (settings.dateStart) {
        if (!currentDate.isAfter(settings.dateStart)) {
            return false;
        }
    }
    if (settings.dateEnd) {
        if (!currentDate.isBefore(settings.dateEnd)) {
            return false;
        }
    }
    if (settings.timeStart) {
        if (
            !currentDate.isAfter(`${currentDateString}T${settings.timeStart}`)
        ) {
            return false;
        }
    }
    if (settings.timeEnd) {
        if (!currentDate.isBefore(`${currentDateString}T${settings.timeEnd}`)) {
            return false;
        }
    }

    if (settings.daysSettings) {
        const currentDay = dayJsToDaysOfWeekMap[currentDate.day()];
        const currentDaySettings = settings.daysSettings[currentDay];
        const isSettingsByDayEnabled = Object.values(
            settings.daysSettings,
        ).some((day) => !!day);

        if (!isSettingsByDayEnabled) {
            return true;
        }

        if (!currentDaySettings || !currentDaySettings?.enabled) {
            return false;
        }

        if (currentDaySettings.start) {
            if (
                !currentDate.isAfter(
                    `${currentDateString}T${currentDaySettings.start}`,
                )
            ) {
                return false;
            }
        }
        if (currentDaySettings.end) {
            if (
                !currentDate.isBefore(
                    `${currentDateString}T${currentDaySettings.end}`,
                )
            ) {
                return false;
            }
        }
    }

    return true;
};
